import "../../includes/extensions/blocks/core/query/view";
function updateViewAllLinksInForm(form: HTMLFormElement, queryLoopForm = plaudit.queryLoop.forms.get(form)) {
	if (!queryLoopForm) {
		return;
	}
	for (const link of form.querySelectorAll<HTMLAnchorElement>('a.pql-view-all-link')) {
		const baseUrl = link.getAttribute('data-base-url') ?? link.href;
		if (baseUrl) {
			const url = new URL(baseUrl);
			for (const field of queryLoopForm.getFields()) {
				if (field.field.getAttribute('data-include-in-view-all-query') !== 'false') {
					field.loadIntoQuery(url.searchParams);
				}
			}
			link.href = url.toString();
		}
	}
}
document.addEventListener('queryLoopFormValueChange', event => updateViewAllLinksInForm(event.detail.form, event.detail));
document.addEventListener('queryLoopFormInitialized', event => updateViewAllLinksInForm(event.detail.form, event.detail));
